import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, CDN_URL, formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import SubscriptionExpiredWidget from '../ones/SubscriptionExpiredWidget';
import { RxHeart, RxHeartFilled } from "react-icons/rx";
import { FaRegCommentDots } from "react-icons/fa6";
import { STR_BUY_NOW, STR_CART_WAS_UPDATED, STR_CLICK_TO_VIEW_COMMENTS, STR_WRITE_YOUR_COMMENT } from "../Strings";
import LoginView from '../views/LoginView';
import ImagesSlider from "../ones/ImagesSlider";
import { MdAdd } from "react-icons/md";
import { BiMinus, BiSolidCartDownload } from "react-icons/bi";


export default function View({ id }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [images, setImages] = useState([]);
	const [data, setData] = useState(null);
	const [quantity, setQuantity] = useState(1);
	


	async function init() {
		//run initializations here
		setReady(false);
		await getData();
		setReady(true);
	}

	function buyNow() {
		appContext.setPharmacyItemForCheckout({
			itemId: data.id,
			itemQuantity: quantity,
		});

		appContext.navTo({
			item: 'bottom-view',
			subItem: 'pharmacy-item-checkout',
		})
	}

	function addToCart() {
		appContext.addItemToCart({
			itemId: data.id,
			itemQuantity: quantity,
		});

		appContext.tellInfo(STR_CART_WAS_UPDATED[appContext.language]);
	}

	function getImages() {
		if (data) {
			const _images = [];

			if (data.photo1) {
				_images.push(CDN_URL + data.photo1)
			}

			if (data.photo2) {
				_images.push(CDN_URL + data.photo2)
			}

			if (data.photo3) {
				_images.push(CDN_URL + data.photo3)
			}

			

			setImages(_images);
		}
	}

	async function getData() {
		await callApi("get-pharmacy-item-data", { id }).then(response => {
			if (response.status === 1) {
				setData(response.data);
			}
		})
	}


	useEffect(() => {
		init();
	}, [])


	useEffect(() => {
		getImages();
	}, [ data ])
	
	if (ready && data) {
		return (
			<div className="container">
				<div className="row">

					<div className="col-md-6">
						<ImagesSlider images={images} />
					</div>
					
					<div
						className="col-md-6"
					>
						<h6
							className="font-semi-bold text-secondary mt-4 mb-4"
							style={{
								fontSize: "22px"
							}}
						>
							{data.title}
						</h6>
		
					
						<h6
							className="text-end mTwoLineText"
							style={{
								fontSize: "32px"
							}}
							
						>
							<span 
								className="font-semi-bold d-block" 
								style={{ 
									fontSize: "12px", 
									textTransform: "uppercase" 
								}}
							>
								<span style={{ fontSize: "12px" }} className="badge bg-dark">{data.unit}</span>
							</span>
							<span style={{ fontSize: "20px" }}>TZS</span> <span className="font-bold">{formatMoney(data.unitPrice)}</span>
							
						</h6>
		
						<div 
							className="d-flex justify-content-between mt-4 mb-4 bg-surface"
							style={{
								width: "100%",
								padding: "10px",
								borderRadius: "10px"
							}}
						>
		
							<div
								className="align-self-center d-flex"
								style={{
									flexShrink: "0",
								}}
							>
								<MdAdd
									className="align-self-center"
									size={24}
									onClick={(e) => {
										e.stopPropagation();
										setQuantity((_prev) => {
											return _prev + 1;
										})
									}}
								/>
		
								<input
									className="form-control text-center font-bold"
									style={{
										width: "40px",
										fontSize: "12px",
										padding: "2px"
									}}
									value={quantity}
									onChange={(e) => {
										if(!isNaN(Number(e.target.value)) && Number(e.target.value) > 0) {
											setQuantity(Number(e.target.value))
										}
									}}
									onClick={(e) => {
										e.stopPropagation();
									}}
								/>
		
								<BiMinus
									className="align-self-center"
									size={24}
									onClick={(e) => {
										e.stopPropagation();
										setQuantity((_prev) => {
											if(_prev - 1 > 0) {
												return _prev - 1;
											} else {
												return _prev;
											}
										})
									}}
								/>
							</div>
		
							<BiSolidCartDownload
								className="align-self-center text-secondary"
								size={36}
								onClick={addToCart}
							/>
						</div>

						<pre
							style={{
								fontSize: "18px"
							}}
						>
							{data.description}
						</pre>

						<button
							className="btn btn-block btn-padded btn-primary btn-rounded"
							onClick={buyNow}
						>
							{STR_BUY_NOW[appContext.language]}
						</button>
		
					</div>
					
					

				</div>
			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading container"
			>
				{getInlineLoader()}
			</div>
		);
	}
	

}